<div class="fs-4 fw-bold">New {{entitytype}}</div>
<div class="mt-2">
  <form class="m-2">
    @if (entitytype === 'Incident' || entitytype === 'Geofence') {
      <div
        class="row g-2 pb-2 bg-illum text-white px-2 pt-3 rounded">
        <div class="col-md-3">
          <label class="form-label">Organization</label>
          <select class="form-control"
            [(ngModel)]="selectedOrganization"
            (ngModelChange)="onSelectedOrgChanged()"
            name="selectedOrganization"
            title="select organization">
            @for (org of organizations; track org) {
              <option [ngValue]="org">{{ buildAncestorLabel(org) }}</option>
            }
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Category</label>
          <select class="form-control"
            [(ngModel)]="selectedIncidentCategory"
            (ngModelChange)="incidentCategorySelected()"
            name="selectedIncidentCategory"
            title="select incident category">
            @for (item of orgIncidentCategoryList; track item) {
              <option [ngValue]="item">{{item.label}}</option>
            }
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Type</label>
          <select class="form-control"
            [(ngModel)]="selectedIncidentType"
            name="selectedIncidentType"
            title="select incident type">
            @for (item of incidentTypeList; track item) {
              <option [ngValue]="item">{{item.label}}</option>
            }
          </select>
        </div>
      </div>
    }
    <div class="form-label bg-illum text-white px-2 mt-2 py-1 d-block">Name</div>
    <input type="text" class="form-control" placeholder="{{entitytype}} name"
      [(ngModel)]="name" name="name" />


      @if (entitytype !== 'Geofence') {
        <div>
          <div class="form-label bg-illum text-white px-2 py-1 mt-2 d-block">Description</div>
          <textarea type="text" class="form-control" placeholder="{{entitytype}} description"
          [(ngModel)]="description" name="description"></textarea>
        </div>
      }

      <!-- <div *ngIf="entitytype === 'Geofence'">
      <br>
        <div>User</div>
        <select class="form-control"
          [(ngModel)]="selectedUser"
          (change)="userChanged($event.target.value)"
          style="width: 40%;">
          <option *ngFor="let c of userSearch" [ngValue]="c">{{c.name}}</option>
        </select>
        <br><br>
      </div> -->

      @if (error) {
        <div>
          <br>
            <div class="alert alert-danger" role="alert">
              {{errorMessage}}
            </div>
          </div>
        }
        <br>
          <div class="d-flex justify-content-center gap-2 mt-2">
            <button type="button" class="btn btn-primary" (click)="confirmPublicIncident()">Create</button>
            <button type="button" class="btn btn-secondary" (click)="cancelDialog()">Cancel</button>
          </div>
        </form>
      </div>
